import AntdPopconfirm, { type PopconfirmProps as AntdPopconfirmProps } from "antd/lib/popconfirm";

export type PopconfirmProps = AntdPopconfirmProps;

export const Popconfirm = (props: PopconfirmProps) => {
    return <AntdPopconfirm {...props} />;
};
